module.exports = __webpack_public_path__ + "static/media/chess.9c782ab7.avif";